"use client";
import React, { useEffect, useRef, useState } from 'react';
import {manrope, ubuntu} from "@/ui/fonts";

export default function Whatsapp() {
  const [selected, setSelected] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);
	const wppButton = useRef(null);
	const wppForm = useRef(null);
	const closeButton = useRef(null);
	const phone = useRef(null);
	const mask = useRef(null);
	const response = useRef(null);
	const wppoptions = useRef(null);

	useEffect(() => {
		function getData(form) {
			const formData = new FormData(form);
			return Object.fromEntries(formData.entries());
		}

		function phoneMask(value) {
			if (!value) return '';
			value = value.replace(/\D/g, '');
			value = value.replace(/(\d{3})(\d)/, '($1) $2');
			value = value.replace(/(\d)(\d{4})$/, '$1-$2');
			return value;
		}

		if (phone.current) {
			phone.current.onkeyup = (e) => {
				const target = e.target;
				phone.current.value = phoneMask(target.value);
			};
		}

		if (wppButton.current) {
			wppButton.current.onclick = () => {
				wppButton.current.classList.add('hide-this');
				setIsFormOpen(true); // 🆕 Show overlay
			};
		}

		if (mask.current) {
			mask.current.onclick = () => {
				wppButton.current.classList.remove('hide-this');
				setIsFormOpen(false); // 🆕 Hide overlay
			};
		}

		if (closeButton.current) {
			closeButton.current.onclick = () => {
				wppButton.current.classList.remove('hide-this');
				setIsFormOpen(false); // 🆕 Hide overlay
			};
		}

		const handleSubmit = async (e) => {
			e.preventDefault();
		  
			const formData = getData(e.target);
			wppForm.current.classList.add('submitting');
			response.current.innerHTML += '<p>Serás redirigido a WhastApp.</p>';
		  
			const sheetData = {
			  data: {
				"Fecha": new Date().toLocaleString(),
				"Venta/postventa": selected,
				"Nombre": formData.firstname,
				"Teléfono": formData.phone,
				"Correo": formData.email,
			  }
			};
		  
			try {
			  const res = await fetch("https://sheetdb.io/api/v1/y6q4rlbn1y2py", {
				method: "POST",
				headers: {
				  'Accept': 'application/json',
				  "Content-Type": "application/json"
				},
				body: JSON.stringify(sheetData)
			  });
		  
			  const data = await res.json();
			  console.log("Response from SheetDB:", data);

		  
			  setTimeout(() => {
				wppForm.current.classList.remove('submitting');
				wppForm.current.classList.add('hide-this');
				response.current.innerHTML = '';

				// 🔽 Clear all inputs and selects inside the form
				const inputs = wppForm.current.querySelectorAll('input, select, textarea');
				inputs.forEach((input) => {
					if (input.tagName.toLowerCase() === 'select') {
					input.selectedIndex = 0;
					} else {
					input.value = '';
					}
				});
				setSelected('')
		  
				setTimeout(() => {
				  window.open(`https://api.whatsapp.com/send?text=Hola mi nombre es ${formData.firstname}, ¡Me gustaría saber más sobre sus productos! Este es mi contacto:%0D%0A Teléfono: ${formData.phone} %0D%0A Correo Electrónico: ${formData.email}&phone=573222102466`, '_blank');
				}, 700);
			  }, 2000);
			} catch (error) {
			  console.error("Error:", error);
			}
		  };
		  

		if (wppForm.current) {
			wppForm.current.addEventListener('submit', handleSubmit);
		}

		document.addEventListener('keyup', (e) => {
			if (e.key === 'Escape' && wppButton.current) {
				wppButton.current.classList.remove('hide-this');
				setIsFormOpen(false); // 🆕 Hide overlay
			}
		});

		if (wppoptions.current) {
			wppoptions.current.addEventListener('change', (e) => {
				const target = e.target;
				const selectedItem = target.value;
				console.log(selectedItem);
			});
		}

		return () => {
			if (wppForm.current) {
				wppForm.current.removeEventListener('submit', handleSubmit);
			}
		};
	}, [setIsFormOpen, selected]);

  const RadioIcon = ({ active }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <circle cx="8" cy="8" r="6" stroke="black" strokeWidth="2.5" />
      {active && <circle cx="8" cy="8" r="2" fill="black" stroke="black" />}
    </svg>
  );

	// JSX part remains unchanged
	return (
		<div className={`${manrope.className}`}>
			{/* 🔥 Overlay */}
			<div
				ref={mask}
				className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300 ${
				isFormOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
				}`}
			/>
			<p className="message hidden">WhatsApp Button</p>
			<div id="wpp-fix" className="right shake">
				<button id="wpp-link" ref={wppButton} className="wpp-form wpp-link">
        <span>Chamar no WhatsApp</span>
        <svg height="682pt" viewBox="-23 -21 682 682.667" width="682pt" xmlns="https://www.w3.org/2000/svg"><path d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94zm144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254zm0 0" fillRule="evenodd"></path></svg>
				</button>

				<div className="form-wpp">
					<div className="head-wpp">
						<button ref={closeButton}>
              <svg width="24" height="24" className='mx-2' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M11.4375 18.75L4.6875 12L11.4375 5.25" stroke="white" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M5.625 12H19.3125" stroke="white" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</button>
						<img src="http://test.mincaelectric.com/wp-content/uploads/2025/04/9c9d8867e5dc045195c2246d5f9c06c2.png" loading="lazy" width="50" height="50" alt="Imagem perfil" />
						<div className='flex flex-col'>
							<h3>Minca Electric™</h3>
							<span className='text-[12px] font-extralight text-white'>online</span>
						</div>
					</div>

					<div className="form-content">
						<p className="buss-msg">Hola, ¿Cómo te podemos ayudar hoy? Por favor selecciona una opción.</p>

						<form action="/" method="post" ref={wppForm} id="wpp-form">
              <div className="flex flex-col">
                <div className="buss-msg flex items-center lg:!-ml-12 cursor-pointer">
                  <input
                    type="radio"
                    id="sell"
                    name="sell-type"
                    className="hidden"
                    checked={selected === 'Ventas'}
					required
                    onChange={() => setSelected('Ventas')}
                  />
                  <div className='-mb-2' onClick={() => setSelected('Ventas')}>
                    <RadioIcon active={selected === 'Ventas'} />
                  </div>
                  <label htmlFor="sell" className="cursor-pointer select-none">Ventas</label>
                </div>

                <div className="buss-msg flex items-center lg:!-ml-12 cursor-pointer">
                  <input
                    type="radio"
                    id="postsell"
                    name="sell-type"
                    className="hidden"
					required
                    checked={selected === 'Postventa'}
                    onChange={() => setSelected('Postventa')}
                  />
                  <div className='-mb-2' onClick={() => setSelected('Postventa')}>
                    <RadioIcon active={selected === 'Postventa'} />
                  </div>
                  <label htmlFor="postsell" className="cursor-pointer select-none">Postventa</label>
                </div>
              </div>
							<div className="campo">
								<label htmlFor="firstname" className="hidden">Nombre</label>
								<span className="form-control-wrap">
									<input type="text" name="firstname" aria-required="true" placeholder="Nombre" required />
								</span>
							</div>
							<div className="campo">
								<label htmlFor="phone" className="hidden">Teléfono</label>
								<span className="form-control-wrap">
									<input type="text" name="phone" ref={phone} id="phone" aria-required="true" placeholder="Teléfono" maxLength="14" pattern=".{14,15}" title="Inserta un numero valido" required />
								</span>
							</div>
              <div className="campo">
								<label htmlFor="email" className="hidden">Correo Electrónico</label>
								<span className="form-control-wrap">
									<input type="email" name="email" aria-required="true" placeholder="Correo Electrónico" required />
								</span>
							</div>
							<span className='text-[9px] lg:text-[12px] lg:-ml-12 whitespace-nowrap'>Al momento de iniciar aceptas los <a target="_blank" rel="noopener noreferrer" className='font-bold underline mt-4 mb-2' href="https://www.mincaelectric.com/declaracionPrivacidad">términos y condiciones.</a></span>
              <div className="btn whatsapp">
								<button type="submit">
									Iniciar Conversación
								</button>
							</div>
							<div className="response-output" ref={response}></div>
						</form>
						<div ref={response}></div>
					</div>
				</div>
			</div>
		</div>
	);
}
